// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Voce a menu selezionata*/
.SidebarLeft_active__u9tc\\+ {
    color: var(--principale) !important;
}
.SidebarLeft_active__u9tc\\+ .SidebarLeft_scritta__FZF9q {
    color: var(--principale) !important;
    font-weight: 500 !important;
}
  

.SidebarLeft_sidebarContainer__wucMY {
    z-index: 2;
    top: 0;
    bottom: 0;
    transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
    background: var(--secondario);
    min-height: 100vh;
    width: 100%;
    max-width: 300px;
    padding: 100px 20px 20px 20px;
    color: white;
}
@media only screen and (max-width:900px) {
    .SidebarLeft_sidebarContainer__wucMY {
        position: absolute;
    }
}
.SidebarLeft_sidebarContainer__wucMY.SidebarLeft_collapsed__cYZdC {
    position: relative;
    width: 60px;
}

.SidebarLeft_contenutoSidebar__xu949 {
    position: fixed;
    width: 100%;
    max-width: 249px;
}
.SidebarLeft_contenutoSidebar__xu949.SidebarLeft_collapsed__cYZdC {
    width: 24px;
}


.SidebarLeft_chiudiSidebar__fwvgU {
    margin-bottom: 110px;
    text-align: right;
}


.SidebarLeft_riga__kkhaH {
    display: flex;
    margin-bottom: 20px;
}

.SidebarLeft_scritta__FZF9q {
    font-weight: 300;
}
.SidebarLeft_scritta__FZF9q.SidebarLeft_collapsedScritta__6qx93 {
    display: none;
}
.SidebarLeft_riga__kkhaH {
    color: white;
    text-decoration: none !important;
    font-size: 18px;
    font-weight: 500;
}
.SidebarLeft_sidebarContainer__wucMY a {
    text-decoration: none !important;
}
.SidebarLeft_riga__kkhaH svg {
    transform: translateY(-2px);
    margin-right: 7px;
}


.SidebarLeft_logout__n1lOH {
    position: fixed;
    bottom: 51px;
}

.SidebarLeft_divider__bd6HL {
    border: none;
    border-top: 1px solid #ccc; 
    margin: 10px 0 18px 0px;
  }`, "",{"version":3,"sources":["webpack://./src/style/styleComponents/SidebarLeft.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;IACnC,2BAA2B;AAC/B;;;AAGA;IACI,UAAU;IACV,MAAM;IACN,SAAS;IACT,8DAA8D;IAC9D,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;;;AAGA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;EACzB","sourcesContent":["/*Voce a menu selezionata*/\n.active {\n    color: var(--principale) !important;\n}\n.active .scritta {\n    color: var(--principale) !important;\n    font-weight: 500 !important;\n}\n  \n\n.sidebarContainer {\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;\n    background: var(--secondario);\n    min-height: 100vh;\n    width: 100%;\n    max-width: 300px;\n    padding: 100px 20px 20px 20px;\n    color: white;\n}\n@media only screen and (max-width:900px) {\n    .sidebarContainer {\n        position: absolute;\n    }\n}\n.sidebarContainer.collapsed {\n    position: relative;\n    width: 60px;\n}\n\n.contenutoSidebar {\n    position: fixed;\n    width: 100%;\n    max-width: 249px;\n}\n.contenutoSidebar.collapsed {\n    width: 24px;\n}\n\n\n.chiudiSidebar {\n    margin-bottom: 110px;\n    text-align: right;\n}\n\n\n.riga {\n    display: flex;\n    margin-bottom: 20px;\n}\n\n.scritta {\n    font-weight: 300;\n}\n.scritta.collapsedScritta {\n    display: none;\n}\n.riga {\n    color: white;\n    text-decoration: none !important;\n    font-size: 18px;\n    font-weight: 500;\n}\n.sidebarContainer a {\n    text-decoration: none !important;\n}\n.riga svg {\n    transform: translateY(-2px);\n    margin-right: 7px;\n}\n\n\n.logout {\n    position: fixed;\n    bottom: 51px;\n}\n\n.divider {\n    border: none;\n    border-top: 1px solid #ccc; \n    margin: 10px 0 18px 0px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active": `SidebarLeft_active__u9tc+`,
	"scritta": `SidebarLeft_scritta__FZF9q`,
	"sidebarContainer": `SidebarLeft_sidebarContainer__wucMY`,
	"collapsed": `SidebarLeft_collapsed__cYZdC`,
	"contenutoSidebar": `SidebarLeft_contenutoSidebar__xu949`,
	"chiudiSidebar": `SidebarLeft_chiudiSidebar__fwvgU`,
	"riga": `SidebarLeft_riga__kkhaH`,
	"collapsedScritta": `SidebarLeft_collapsedScritta__6qx93`,
	"logout": `SidebarLeft_logout__n1lOH`,
	"divider": `SidebarLeft_divider__bd6HL`
};
export default ___CSS_LOADER_EXPORT___;
